import React from 'react'
import Paper from '@mui/material/Paper'
import styled from '@emotion/styled'
import { Avatar, Box, IconButton, Typography } from '@mui/material'
import VerifiedIcon from '@mui/icons-material/Verified'
import CancelIcon from '@mui/icons-material/Cancel'

const StyledPaper = styled(Paper)({
    position: 'fixed',
    right: 10,
    bottom: 5,
    backgroundColor: '#efeae2',
    zIndex: 999999999,
})

const BoxChat = styled(Box)({
    padding: 10,
    height: 450,
    width: 400,
    backgroundImage: 'url(/img/whatsapp/whatsappbg.png)',
    overflowX: 'scroll',
    overflowY: 'scroll',
    '&:hover': {
        overflowY: 'scroll !important',
    },
    '::-webkit-scrollbar': { width: '3px' },
    '::-webkit-scrollbar-track': { background: '#f1f1f1' },
    '::-webkit-scrollbar-thumb': { background: '#ccc' },
    '::-webkit-scrollbar-thumb:hover': { background: '#555' },
})

const BoxProfile = styled(Box)({
    display: 'flex',
    backgroundColor: '#f0f2f5',
    padding: 10,
    alignItems: 'center',
})

const MessageBox = styled('div')({
    padding: 10,
    fontSize: 14,
    boxShadow: '0 1px 1px rgba(var(--shadow-rgb),.13)',
    display: 'inline-block',
    width: '100%',
    wordBreak: 'break-word',
    whiteSpace: 'pre-wrap',
})

const MessageDiv = styled(Box)({
    marginBottom: 10,
    maxWidth: '90%',
    borderRadius: 10,
    overflow: 'hidden',
    clear: 'both',
})

const FakeNDRWhatsAppConversation = ({ conversation, setConversation, type }) => {
    return (
        <StyledPaper elevation={7}>
            <BoxProfile>
                <Box sx={{ display: 'flex', alignItems: 'center', flex: 1 }}>
                    <Avatar
                        sx={{
                            backgroundColor: 'currentColor',
                            padding: 1,
                            '& img': { objectFit: 'contain' },
                            mr: 2,
                        }}
                        src='/img/logo.png'
                    />
                    <Box>
                        <Typography variant='body1' fontWeight={500} sx={{ mb: '-3px', lineHeight: 1 }}>
                            Proship
                        </Typography>
                        <Typography variant='caption' fontWeight={500}>
                            NDR Conversation <VerifiedIcon sx={{ fontSize: 15, color: 'rgb(0, 218, 96)' }} />
                        </Typography>
                    </Box>
                </Box>
                <IconButton onClick={() => setConversation(null)}>
                    <CancelIcon fontSize='small' />
                </IconButton>
            </BoxProfile>
            <BoxChat>
                {conversation.length === 0 && (
                    <Typography sx={{ textAlign: 'center' }}>No Conversation</Typography>
                )}
                <Typography
                    component='div'
                    sx={{
                        textAlign: 'center',
                        marginBottom: '10px',
                        color: 'black',
                        fontSize: '13px',
                        fontWeight: 500,
                        float: 'right',
                        display: 'block',
                        width: '100%',
                    }}
                >
                    {type === 'w' ? 'WhatsApp Conversation History' : 'Telecalling Conversation History'}
                </Typography>

                {conversation.map((text) => {
                    const isResponse = text.action !== 'message'
                    const backgroundColor = isResponse ? '#fff' : '#d9fdd3'
                    const float = isResponse ? 'left' : 'right'
                    return (
                        <MessageDiv sx={{ backgroundColor, float }} key={text.id}>
                            <MessageBox>
                                <Typography component='div' sx={{ display: 'block', width: '100%' }}>
                                    {text?.messageValue}
                                </Typography>
                                {text?.isTimeNeeded && (
                                    <Typography sx={{ display: 'block', fontSize: 10, mt: 1, fontWeight: 500 }}>
                                        {text?.timestamp}
                                    </Typography>
                                )}
                            </MessageBox>
                        </MessageDiv>
                    )
                })}
            </BoxChat>
        </StyledPaper>
    )
}

export default FakeNDRWhatsAppConversation
